'use client'

import classNames from 'classnames'

import { useNoiseFilterMode } from '@/src/hooks/room/track/useNoiseFilterMode'
import {
  NOISE_FILTER_OPTIONS,
  type NoiseFilterMode,
} from '@/src/lib/noiseFilter'

import { useAppSelector } from '@/src/store/hooks'
import { selectBranding } from '@/src/store/slices/meetData'

import styles from '@/styles/NoiseFilterSelect.module.css'

/**
 * Список режимов шумодава в стиле MediaDeviceSelect для меню микрофона.
 */
export function NoiseFilterSelect() {
  const { mode, setMode } = useNoiseFilterMode()
  const { primary_color, text_primary_color } = useAppSelector(selectBranding)

  const handleSelect = (value: NoiseFilterMode) => {
    setMode(value)
  }

  return (
    <div className={styles.root}>
      <ul className={`lk-list ${styles.list}`}>
        {NOISE_FILTER_OPTIONS.map((option) => {
          const isActive = option.value === mode

          return (
            <li
              key={option.value}
              data-lk-active={isActive}
              aria-selected={isActive}
              role="option"
            >
              <button
                type="button"
                className={classNames('lk-button', styles.option)}
                style={{
                  color: text_primary_color,
                  backgroundColor: isActive ? primary_color : '',
                }}
                onClick={() => handleSelect(option.value)}
              >
                {option.label}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
